<div class="container-fluid p-4">
    <!-- <div class="d-flex justify-content-between mb-3"> -->
        <h3 class="fw-bold mb-3">E-Invoice {{ currentYear }}</h3>
        <!-- <div class="d-flex align-items-center gap-2">
            <label class="flex-shrink-0" for="year">Fiscal Year:</label>
            <select class="form-select" id="year" [(ngModel)]="selectedYear">
            @for (b of fiscalYears; track b) {
                <option [value]="b">{{ b }}</option>
            }
            </select>
        </div> -->
    <!-- </div> -->
    <!-- <hr> -->
    <div class="d-grid">
        <div>
            <div class="rounded bg-white light-drop-shadow">
                <div class="d-flex justify-content-between align-items-center p-2 border-bottom">
                    <div class="d-flex gap-2 align-items-center pointer" (click)="goToFiscalYearList()">
                        <h5 class="m-0">Businesses With Annual Target</h5>
                        <i class="fas fa-chevron-right text-body-tertiary small"></i>
                    </div>
                    <button class="btn btn-light btn-sm" (click)="addFiscalYearInfo()"><i class="fas fa-plus"></i></button>
                </div>
                <div class="p-3">
                @for (f of currentFyInfo(); track f.BranchId + '-' + f.FiscalYear; let i = $index) {
                    <div class="d-flex gap-3 align-items-center justify-content-between">
                        <div class="fw-semibold">{{ branchBusinessMap().get(f.BranchId).Name }}</div>
                        <div class="d-flex gap-3">
                            <div class="pointer" (click)="addEInvoiceDoc(f.BranchId)"><i class="fas fa-file-invoice-dollar"></i></div>
                            <div class="pointer" (click)="editFiscalYearInfo(f)"><i class="fas fa-pencil-alt"></i></div>
                        </div>
                    </div>
                    @let b = branchMap().get(f.BranchId);
                    <div class="fw-semibold mb-1"><span class="text-secondary">[{{f.FiscalYear}}] </span> {{ b.Name.length > 0 ? b.Name : b.Address.City }}</div>
                    <div class="h5 mb-0 fw-medium">{{ f.Amount | currency: "MYR" : "symbol-narrow" : "1.0-0" }} <span class="small text-secondary">(CF: {{ f.CfAdjustment | currency: "MYR" : "symbol-narrow" : "1.0-0" }})</span></div>
                    @if (i !== currentFyInfo().length - 1) { <hr class="opacity-10"> }
                }
                </div>
            </div>
        </div>
        <div>
            <div class="rounded bg-white light-drop-shadow">
                <app-e-invoice-doc-list></app-e-invoice-doc-list>
            </div>
        </div>
    </div>
</div>